<ng-container *ngIf="isLoading | async">
  <div
    *ngIf="isLoading"
    id="overlay"
    class="d-flex justify-content-center align-items-center"
  >
    <div
      class="ch-ggs-web-suite-order-steps-loader spinner-border text-primary"
      role="status"
    >
      <ng-container *ngIf="layoutResource$ | async as layoutResource">
        <span class="sr-only">{{ layoutResource['Loading'] }}</span>
      </ng-container>
    </div>
  </div>
</ng-container>
